var module = angular.module('octopusApp.projects');

module.directive('deploymentCreateTenantSelector', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            edit: '=',
            allTenants: '=',
            selectedEnvironments: '=',
            selectedTenants: '=',
            selectedTags: '=',
            resultantTenants: '=',
            resultantTenantCount: '=',
            project: "=",
            template: "=",
            channel: "=",
            newDeployments: '=',
            loadMatches: '='
        },
        templateUrl: 'areas/projects/deployment-create/deployment-create-tenant-selector.html',
        controllerAs: 'vm',
        bindToController: true,
        controller: function ($scope, $q, busy, pollLoop, octopusTagSets, octopusRepository) {
            var vm = this;

            vm.customTenantFilter = customTenantFilter;
            vm.setSelectedEnvironment = setSelectedEnvironment;
            vm.getMissingTenantVariables = getMissingTenantVariables;
            vm.hasSelectedTenantsWithMissingVariables = hasSelectedTenantsWithMissingVariables;
            vm.loadMatches = loadMatches;
            vm.applySelection = applySelection;

            vm.selectedEnvironment = null;
            vm.tenantsById = {};
            vm.warning = null;
            vm.availableEnvironments = [];
            vm.tagMatchedTenants = [];

            var tenantPromotionsIndex = {};
            var tenantMissingVariables = {};
            var tenantsForProject = [];
            var tenantsForProjectChannel = [];
            var tenantsWhoCanDeploy = [];
            var tagMatchedLoader;

            function loadMatches() {
                return tagMatchedLoader.then(function () {
                    vm.showMatched = true;
                    var resultantTenants = vm.tagMatchedTenants.map(function (tenant) {
                        return tenant.Id;
                    }).concat(vm.selectedTenants || []);

                    vm.resultantTenants = resultantTenants;
                    vm.resultantTenantCount = resultantTenants.length;
                    return resultantTenants;
                });
            }

            function applySelection() {
                if ((vm.selectedTenants || []).length <= 0 && (vm.selectedTags|| []).length <= 0) {
                    return;
                }
                
                vm.edit = false;
                loadTagMatched(false);
            }

            function loadTagMatched(force) {
                vm.isTagMatchedTenantMissingVariable = false;
                if (!force && (!vm.selectedTags || vm.selectedTags.length === 0)) {
                    return tagMatchedLoader = $q.resolve([]);
                }

                return tagMatchedLoader = octopusRepository.Tenants.tagTest(vm.selectedTenants || [], vm.selectedTags)
                    .then(filterTagMatches)
                    .then(function (matched) {
                        return vm.allTenants.filter(function (tenant) {
                            return matched.indexOf(tenant.Id) !== -1 && !vm.customTenantFilter(tenant);
                        });
                    })
                    .then(function (matched) {
                        vm.tagMatchedTenants = matched.filter(function (tenant) {
                            return vm.selectedTenants.indexOf(tenant.Id) === -1;
                        });

                        vm.isTagMatchedTenantMissingVariable = _.any(vm.tagMatchedTenants, function (tenant) {
                            return tenantMissingVariables[tenant.Id];
                        });
                    });
            }

            function filterTagMatches(result) {
                return Object.keys(result).filter(function (tenantId) {
                    return result[tenantId].IsMatched;
                });
            }

            function init() {
                $scope.$watch(function () {
                    return vm.selectedEnvironments[0];
                }, function () {
                    vm.selectedEnvironment = vm.selectedEnvironments.filter(isEnvironmentAvailable)[0];
                    setSelectedEnvironmentName();
                    setAvailableTenants();
                });

                tenantsForProject = vm.allTenants.filter(function (tenant) {
                    return Object.keys(tenant.ProjectEnvironments).indexOf(vm.project.Id) !== -1;
                });

                tenantPromotionsIndex = vm.template.TenantPromotions.reduce(function(idx, tenantPromo) {
                    idx[tenantPromo.Id] = _.indexBy(tenantPromo.PromoteTo, function(environmentPromo) { return environmentPromo.Id; });
                    return idx;
                }, {});

                tenantsWhoCanDeploy = vm.template.TenantPromotions.filter(function (tenantPromotion) {
                    return tenantPromotion.PromoteTo.length > 0;
                });
                vm.tenantsById = _.object(_.pluck(vm.allTenants, "Id"), vm.allTenants);

                // When the environment changes, check if any tenants are available for environment
                $scope.$watch(function () { return vm.selectedEnvironment; },
                    function () {
                        vm.anyTenantsInThisEnvironment = _.any(vm.allTenants, function (tenant) {
                            return (tenant.ProjectEnvironments[vm.project.Id] || []).indexOf(vm.selectedEnvironment) !== -1;
                        });
                        loadTagMatched(false);
                        loadMatches();
                    });

                $scope.$watch(function () { return vm.selectedTenants; },
                    function () {
                        loadTagMatched(true);
                        loadMatches();
                    });

                $scope.$watch(function () { return vm.selectedTags; },
                    function () {
                        loadTagMatched(true);
                        loadMatches();
                    });

                vm.availableEnvironments =  _.uniq(_.flatten(
                    vm.template.TenantPromotions.map(
                        function(tenantPromotion) { return tenantPromotion.PromoteTo; })),
                    function(promoteTo) { return promoteTo.Id; });
                
                if (!vm.selectedTenants || vm.selectedTenants.length === 0) {
                    if (vm.selectedTags && vm.selectedTags.length > 0) {
                        octopusRepository.Tenants.tagTest([], vm.selectedTags)
                            .then(filterTagMatches)
                            .then(function (result) {
                                tenantsForProjectChannel = result.filter(function (tenantId) {
                                    return _.any(tenantsForProject, function (tenant) {
                                        return tenant.Id === tenantId;
                                    });
                                });
                                setWarningMessage();
                                setAvailableTenants();
                            });
                    } else if (vm.channel.TenantTags.length > 0) {
                        vm.selectedTags = JSON.parse(JSON.stringify(vm.channel.TenantTags));
                        octopusRepository.Tenants.tagTest(vm.selectedTenants || [], vm.channel.TenantTags)
                            .then(filterTagMatches)
                            .then(function (result) {
                                tenantsForProjectChannel = result.filter(function (tenantId) {
                                    return _.any(tenantsForProject, function (tenant) {
                                        return tenant.Id === tenantId;
                                    });
                                });
                                setWarningMessage();
                                setAvailableTenants();
                            });
                    } else {
                        tenantsForProjectChannel = tenantsForProject.map(function (tenant) {
                            return tenant.Id;
                        });
                        setWarningMessage();
                    }
                }

                loadMissingTenantVariables();
                loadTagMatched(false);

                if ((!vm.selectedTenants || vm.selectedTenants.length === 0) &&
                    (!vm.selectedTags || vm.selectedTags.length === 0)
                ) {
                    vm.edit = true;
                }
            }

            function loadMissingTenantVariables() {
                return octopusRepository.Tenants.missingVariables({projectId: vm.project.Id}, true).then(function (result) {
                    tenantMissingVariables = result.reduce(function (tenantIndex, b) {
                        tenantIndex[b.TenantId] = b.MissingVariables.reduce(function (tenantDetails, template) {
                            if (template.EnvironmentId) {
                                tenantDetails.envDetails[template.EnvironmentId] = (tenantDetails.envDetails[template.EnvironmentId] || []);
                                tenantDetails.envDetails[template.EnvironmentId].push(template.VariableTemplateName);
                            } else {
                                tenantDetails.allDetails.push(template.VariableTemplateName);
                            }
                            return tenantDetails;
                        }, {envDetails: {}, allDetails: []});
                        return tenantIndex;
                    }, {});
                });
            }

            function isEnvironmentAvailable(envId) {
                return _.any(vm.availableEnvironments, function (env) {
                    return env.Id === envId;
                });
            }

            function setSelectedEnvironment() {
                vm.selectedEnvironments.length = 0;
                vm.selectedEnvironments.push(vm.selectedEnvironment);

                setSelectedEnvironmentName();
                setAvailableTenants();
            }

            function setAvailableTenants() {
                vm.availableTenants = vm.allTenants.filter(function (tenant) {
                    var isAvailable = !customTenantFilter(tenant);
                    if (!isAvailable) {
                        var currentIndex = vm.selectedTenants.indexOf(tenant.Id);
                        if (currentIndex !== -1) {
                            vm.selectedTenants.splice(currentIndex, 1);
                        }
                    }
                    return isAvailable;
                });

                vm.anyTenantsInThisEnvironment = vm.availableTenants.length > 0;
            }

            function setSelectedEnvironmentName() {
                if (!vm.selectedEnvironment) {
                    vm.selectedEnvironmentName = null;
                    vm.edit = true;
                } else {
                    var selectedEnvironment = vm.availableEnvironments.filter(function (env) {
                        return env.Id === vm.selectedEnvironment;
                    })[0];
                    vm.selectedEnvironmentName = selectedEnvironment.Name;
                }
            }

            function setWarningMessage() {
                vm.warning = null;

                if (tenantsForProject.length === 0) {
                    return vm.warning = {
                        title: "There are no tenants connected to this project.",
                        message: "Connect at least one tenant to this project to start performing tenanted deployments of this project. To do this, find the tenant, and connect it to this project targeting the desired environments."
                    };
                }

                if (tenantsForProjectChannel.length === 0) {
                    return vm.warning = {
                        title: "There are no matching tenants for the " + vm.channel.Name + " channel.",
                        message: "Releases in the " + vm.channel.Name + " channel can only be deployed to matching tenants. Either change the tenant filter on the channel, tag an existing tenant so they match the channel filter, or create a new tenant tagged to match the channel filter."
                    };
                }

                if (tenantsWhoCanDeploy.length === 0) {
                    if (vm.project.RequireTenantedDeployment) {
                        return vm.warning = {
                            title: "Cannot deploy to any of the connected tenants in this phase of the lifecycle.",
                            message: "Releases of this project can only be deployed to tenants, but there are no tenants connected to any environments in the current lifecycle phase. " +
                            (vm.availableEnvironments.length > 0 ? "Available environments are: " + vm.availableEnvironments : '') +
                            "Either connect an existing tenant to one of the environments in this lifecycle phase, or create a new tenant and connect them to one of the environments in this lifecycle phase, or modify the lifecycle, or configure the project to allow un-tenanted deployments."
                        };
                    } else {
                        return vm.warning = {
                            title: "Cannot deploy to any of the connected tenants in this phase of the lifecycle.",
                            message: "Either perform an un-tenanted deployment of this release to an environment in this lifecycle phase, or connect an existing tenant to one of the environments in this lifecycle phase, or create a new tenant and connect them to one of the environments in this lifecycle phase, or modify the lifecycle."
                        };
                    }
                }
            }

            function customTenantFilter(tenant) {
                var environments = tenant.ProjectEnvironments[vm.project.Id];
                if (!environments) {
                    return "Tenant is not connected to this project.";
                }

                if (tenantsForProjectChannel.length !== 0 && tenantsForProjectChannel.indexOf(tenant.Id) === -1) {
                    return "Tenant is not connected to this channel.";
                }

                if (environments.indexOf(vm.selectedEnvironment) === -1) {
                    return "Tenant is not connected to this environment.";
                }

                if (!tenantPromotionsIndex[tenant.Id]) {
                   return "Tenant is not available for deployment. This may be because you do not have permission to deploy for this tenant.";
                }

                if (!tenantPromotionsIndex[tenant.Id][vm.selectedEnvironment]) {
                    return "Tenant has not reached this lifecycle phase.";
                }

                return null;
            }

            function getMissingTenantVariables(tenantId) {
                if (!tenantMissingVariables[tenantId]) {
                    return [];
                }

                var projectVariables = tenantMissingVariables[tenantId].envDetails[vm.selectedEnvironment] || [];
                var libraryVariables = tenantMissingVariables[tenantId].allDetails;

                return [].concat(libraryVariables).concat(projectVariables);
            }

            function hasSelectedTenantsWithMissingVariables() {
                return _.any(vm.selectedTenants, function (tenantId) {
                    return getMissingTenantVariables(tenantId).length > 0;
                });
            }

            octopusTagSets.getAll().then(function (tagSets) {
                vm.tagSets = tagSets;
                init();
            });

        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/deployment-create/deployment-create-tenant-selector.js
// module id = 532
// module chunks = 1